import React from "react";
import { useState, useRef } from "react";
import { createPortal } from "react-dom";
import { MicroPipette } from "@learningblocks/storybook-components/lib/PhotosynthesisComponents/MicroPipette";
import { SimManager } from "@learningblocks/simulation-engine";
import { MoveMenu } from "@learningblocks/simulation-engine";
import { Vector3 } from "@learningblocks/simulation-engine";
import { usePipette } from "./store";

const Pipette = ({
  id,
  moveMenu,
}: {
  id: string;
  moveMenu?: { [key: string]: Vector3 };
}) => {
  const [showVolumeModal, setShowVolumeModal] = useState(false);
  const moveMenuRef = useRef<any>(null);
  const hamburgerButtonRef = useRef<HTMLElement>(null);
  const [
    { filled, type, hasTip, droppedOn, volume, plungerTooltip, solutionColor },
    actions,
  ] = usePipette(id);

  // Create a controllable object for the move menu
  const defaultControllableObject = {
    props: { id: `${id}` },
    removeMoveMenuButton: () => {},
    getCurrentState: () => "default",
  } as any;

  // Function to open move menu
  const openMoveMenu = () => {
    moveMenuRef.current?.openMoveMenu();
  };

  // Function to set hamburger button ref
  const setHamburgerButtonRef = (ref: React.RefObject<HTMLElement>) => {
    (hamburgerButtonRef as any).current = ref.current;
    moveMenuRef.current?.setHamburgerButtonRef(ref);
  };

  React.useEffect(() => {
    if (moveMenuRef.current) {
      if (moveMenu) {
        const moveMenuOptions = Object.keys(moveMenu);
        moveMenuRef.current.setMoveMenuOptions(moveMenuOptions);
      }
    }
  }, [id, moveMenu]);

  // Get the container element for portaling the modal
  const containerElement =
    typeof document !== "undefined"
      ? document.getElementById("container") || document.body
      : null;

  return (
    <>
      <MicroPipette
        type={type}
        hasTip={hasTip}
        solution={filled && solutionColor}
        volume={volume}
        showVolumeModal={showVolumeModal}
        contactElement={droppedOn || {}}
        plungerTooltip={plungerTooltip}
        notebookExpanded={true}
        setVolume={actions.setVolume}
        toggleShowVolumeModal={() => {
          SimManager.getInstance().setInputValue("sim_state", {
            [`PIPETTE_SHOW_VOLUME_MODAL_${type}`]: !showVolumeModal,
          });
          setShowVolumeModal(!showVolumeModal);
        }}
        removeTip={actions.removeTip}
        setTip={actions.setTip}
        togglePlungerTooltip={actions.togglePlungerTooltip}
        onFirstStopper={actions.onFirstStopper}
        onSecondStopper={() => actions.onSecondStopper({ id, droppedOn })}
        onMix={actions.onMix}
        openMoveMenu={openMoveMenu}
        showMoveMenu={moveMenu ? true : false}
        onSetHamburgerButtonRef={setHamburgerButtonRef}
      />
      {/* Render MoveMenu using portal to ensure it's at document level */}
      {containerElement &&
        createPortal(
          <MoveMenu
            item={defaultControllableObject}
            ref={moveMenuRef}
            hamburgerButtonRef={hamburgerButtonRef}
          />,
          containerElement
        )}
    </>
  );
};

export default Pipette;
